import { Controller } from "@hotwired/stimulus"

// Edit balance payment: toggle manual sales tax fields when switching to/from charge or package lines.
export default class extends Controller {
    static targets = ["transactionSelect", "manualSalesTaxGroup", "amount", "amountError"]
    static values = { minimumAmount: Number }

    connect() {
        this.toggleManualSalesTax()
    }

    toggleManualSalesTax() {
        if (!this.hasManualSalesTaxGroupTarget) return
        const v = this.transactionSelectTarget.value
        const hideTax = v === "charge" || v === "bought_package"
        this.manualSalesTaxGroupTarget.style.display = hideTax ? "none" : "block"
    }

    validateAmount(event) {
        const rawAmount = this.amountTarget.value.trim()
        const amount = Number(rawAmount)
        let message = null

        if (rawAmount === "" || !Number.isFinite(amount)) {
            message = "Enter an amount."
        } else if (amount < this.minimumAmountValue) {
            message = this.minimumAmountValue === 0
                ? "Amount cannot be negative."
                : "Amount must be greater than $0.00."
        } else if (!/^\d+(\.\d{1,2})?$/.test(rawAmount)) {
            message = "Enter an amount with no more than two decimal places."
        }

        if (!message) return

        event.preventDefault()
        this.amountErrorTarget.textContent = message
        this.amountErrorTarget.classList.remove("u-hidden")
        this.amountTarget.focus()
    }

    clearAmountError() {
        this.amountErrorTarget.textContent = ""
        this.amountErrorTarget.classList.add("u-hidden")
    }
}
